'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = ['M16 304c0 87.1 77.5 160 176 160s176-72.9 176-160c0-53-43-96-96-96-26.9 0-51.1 11-68.6 28.8l-11.4 11.7-11.4-11.7c-17.4-17.8-41.7-28.8-68.6-28.8-53 0-96 43-96 96zM361.4 462.7c7.4 .9 14.9 1.3 22.6 1.3 98.5 0 176-72.9 176-160 0-53-43-96-96-96-19.7 0-38.1 5.9-53.3 16.2 13.6 23.5 21.3 50.8 21.3 79.8 0 63.2-27.3 118.7-70.6 158.7z', 'M279.3 0l-94 219.3C165.7 202.3 140 192 112 192 50.1 192 0 242.1 0 304 0 401.2 86 480 192 480s192-78.8 192-176c0-61.9-50.1-112-112-112-25.2 0-48.5 8.3-67.2 22.4L289.5 16.9 412.2 204.6c-3.5 1.8-7 3.9-10.2 6.1 3.1 4.3 6 8.8 8.7 13.4 15.3-10.2 33.6-16.2 53.3-16.2 53 0 96 43 96 96 0 87.1-77.5 160-176 160-7.7 0-15.2-.4-22.6-1.3-5.2 4.8-10.6 9.4-16.2 13.7 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-12.9 0-25.3 2.2-36.8 6.2L297.6 0 279.3 0zM180.6 236.8l11.4 11.7 11.4-11.7c17.4-17.8 41.7-28.8 68.6-28.8 53 0 96 43 96 96 0 87.1-77.5 160-176 160S16 391.1 16 304c0-53 43-96 96-96 26.9 0 51.1 11 68.6 28.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;